import React from 'react'
import { ColumnFilter } from '../ColumnFilter'
import * as BS from "react-bootstrap"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDoubleRight} from '@fortawesome/free-solid-svg-icons'


export const COLUMNS = [
  {
    Header: 'Banque',
    accessor: 'BanqueLogo',
    Filter: ColumnFilter,
    sticky: 'left',
    width: 170,
    wide: 'yes',
    post: 'yes',
    mobile: 'no',
    aVirementsSortants: 'yes',
    aVirementsEntrants: 'yes',
    aDecouverts: 'yes',
    aIrregularites: 'yes',
    aRetraitsEtranger: 'yes',
    aAssurances: 'yes',

    Cell: e =>{
      let val = e.value.split(',')
      
      return (

       <div style={{marginTop: 15}}>
         <a href={`/go/?go=${val[0]}`}
         target='_blank' rel="noreferrer">
         <img style={{width: 150, height: 46}} src={`/logos/${val[0].replace(' ', '-').replace('.', '').replace('é', 'e').replace('é', 'e').replace('é', 'e').replace('é', 'e').toLowerCase()}.png`} alt={`${e.value}`}></img>
       </a>

         </div>
      )
    },
  },
 
  {
    Header: 'Carte bancaire',
    accessor: 'BanqueCarte',
    Filter: ColumnFilter,
    sticky: 'left',
    width: 150,
    wide: 'yes',
    post: 'yes',
    mobile: 'no',
    Cell: e =>{
      let val = e.value.split(',')
      
      return (

       <div style={{marginTop: -5}}>
         <a href={`/go/?go=${val[0]}`}
         target='_blank' rel="noreferrer">
         <img style={{width: 130, marginLeft: 10}} src={`/cartes/carte-bancaire-${val[0].replace(' ', '-').replace('é', 'e').replace('é', 'e').replace('é', 'e').replace('é', 'e').toLowerCase()}-${val[1].replace(' ', '-').replace(' ', '-').replace('é', 'e').replace('é', 'e').replace('é', 'e').replace('é', 'e').toLowerCase()}.jpg`} alt={`${e.value}`}></img>
       </a>

         </div>
      )
    },
  },
 
  


  {
    Header: 'Coût mensuel',
    accessor: 'TarifCarte',
    Filter: ColumnFilter,
    width: 160,
    padding: 27,
    wide: 'yes',
    post: 'yes',
    mobile: 'no',
    Cell : e => {
      
      if(e.value === 'illimité'){
        return (
          <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
            <div style={{fontSize: 20, padding: 8}}>{e.value}</div>
          </div> 
        )
      } else {
        return (
          <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
          <div style={{fontSize: 24, marginTop: 10}}>{e.value}€</div>
          <div style={{fontWeight: 300, fontSize: 14, marginTop: -4}}>par mois</div>
        </div>
        )
      }
  }},



  {
    Header: 'Coût annuel',
    accessor: 'TarifCarteParAn',
    Filter: ColumnFilter,
    width: 110,
    padding: 27,
    wide: 'yes',
    post: 'no',
    mobile: 'no',
    Cell : e => {
      
      if(e.value === 'illimité'){
        return (
          <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
            <div style={{fontSize: 20, padding: 8}}>{e.value}</div>
          </div> 
        )
      } else {
        return (
          <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
          <div style={{fontSize: 24, marginTop: 10}}>{e.value}€</div>
          <div style={{fontWeight: 300, fontSize: 14, marginTop: -4}}>par an</div>
        </div>
        )
      }
  }},

  {
    Header: 'Note',
    accessor: 'Note',
    Filter: ColumnFilter,
    width: 145,
    padding: 27,
    wide: 'yes',
    post: 'no',
    mobile: 'no',
    Cell : e => {
     if (!e.value){
        return (
          <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
          <div style={{fontSize: 24, marginTop: 10}}>
             <img style={{width: 65, marginTop: -5}} src={`/cartes/notation-banque.png`} alt='notation banque'></img>
            <div style={{marginTop: -58, fontWeight: 600}}>nd</div></div>
   
        </div>
        )
      }
      
      else {
        return (
          <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
          <div style={{fontSize: 24, marginTop: 10}}>
             <img style={{width: 65, marginTop: -5}} src={`/cartes/notation-banque.png`} alt='notation banque'></img>
            <div style={{marginTop: -58, fontWeight: 600}}>{e.value}</div></div>
         
        </div>
        )
      }
  }},


  {
    Header: () => (<div style={{float: 'left', marginLeft:39, marginRight: -9, marginTop: -10}}><div>Offre</div><div style={{marginTop: -5}}>promo</div></div>),
    accessor: "OffrePromo",
    Filter: ColumnFilter,
    width: 170,
    padding: 27,
    wide: 'yes',
    post: 'yes',
    mobile: 'no',
    Cell : e => {
      if(e.value === 'illimité'){
        return (
          <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
            <div style={{fontSize: 20, padding: 8}}>{e.value}</div>
          </div> 
        )
      } else {
        return (
          <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
          <div style={{fontSize: 24, marginTop: 10}}>{e.value.split(',')[0]}</div>
          <div style={{fontWeight: 300, fontSize: 14, marginTop: -4}}>{e.value.split(',')[1]}</div>
        </div>
        )
      }
  }},

  {
    Header: "Fin de l'offre",
    accessor: "FinDeLoffre",
    Filter: ColumnFilter,
    width: 140,
    padding: 27,
    wide: 'yes',
    post: 'yes',
    mobile: 'no',
    Cell : e => {
      {
        return (
          <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
          <div style={{fontSize: 20, marginTop: 15}}>{e.value}</div>
        </div>
        )
      }
  }},


  {
    Header: () => (<div style={{float: 'left', marginLeft:29, marginRight: -9, marginTop: -10}}><div>Conditions</div><div style={{marginTop: -5}}>revenu</div></div>),
    accessor: "ConditionRevenu",
    Filter: ColumnFilter,
    width: 150,
    padding: 27,
    wide: 'yes',
    post: 'no',
    mobile: 'no',
    Cell : e => {
      if(e.value === 'Sans condition'){
        return (
          <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
               <div style={{fontSize: 24, marginTop: 10}}>Sans</div>
          <div style={{fontWeight: 300, fontSize: 14, marginTop: -4}}>condition</div>
          </div> 
        )
      } else {
        return (
          <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
          <div style={{fontSize: 24, marginTop: 10}}>{e.value.split(',')[0]}</div>
          <div style={{fontWeight: 300, fontSize: 14, marginTop: -4}}>{e.value.split(',')[1]}</div>
        </div>
        )
      }
  }},


  //////// Virements Sortants /////////


  {
    Header: () => (<div style={{float: 'left', marginLeft:22, marginRight: -9, marginTop: -10}}><div>Virements</div><div style={{marginTop: -5}}>Sortants France</div></div>),
    accessor: "VirementSortantFrance",
    Filter: ColumnFilter,
    width: 150,
    padding: 27,
    wide: 'yes',
    post: 'yes',
    mobile: 'no',
    Cell : e => {
      
        return (
          <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
          <div style={{fontSize: 20, marginTop: 10}}>{e.value}</div>
        </div>
        )
      
  }},


  {
    Header: () => (<div style={{float: 'left', marginLeft:2, marginRight: -9, marginTop: -10}}><div>Virements sort.</div><div style={{marginTop: -5}}>zone UE</div></div>),
    accessor: "VirementSortantZoneEuro",
    Filter: ColumnFilter,
    width: 150,
    padding: 27,
    wide: 'yes',
    post: 'yes',
    mobile: 'no',
    Cell : e => {
      
        return (
          <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
          <div style={{fontSize: 20, marginTop: 10}}>{e.value}</div>
        </div>
        )
      
  }},


  {
    Header: () => (<div style={{float: 'left', marginLeft:15, marginRight: -9, marginTop: -10}}><div>Virements sort.</div><div style={{marginTop: -5}}>hors EU</div></div>),
    accessor: "VirementSortantHorsZoneEuro",
    Filter: ColumnFilter,
    width: 150,
    padding: 27,
    wide: 'yes',
    post: 'yes',
    mobile: 'no',
    Cell : e => {
      
        return (
          <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
          <div style={{fontSize: 20, marginTop: 10}}>{e.value}</div>
        </div>
        )
      
  }},


  {
    Header: () => (<div style={{float: 'left', marginLeft:19, marginRight: -9, marginTop: -10}}><div>Virements Sortants</div><div style={{marginTop: -5}}>Hors EU Taux</div></div>),
    accessor: "VirementSortantsHorsZoneEuroTaux",
    Filter: ColumnFilter,
    width: 170,
    padding: 27,
    wide: 'yes',
    post: 'yes',
    mobile: 'no',
    Cell : e => {
      
        return (
          <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
          <div style={{fontSize: 20, marginTop: 10}}>{e.value}</div>
        </div>
        )
      
  }},

  //////////Virements Entrants ////////////

  {
    Header: () => (<div style={{float: 'left', marginLeft:22, marginRight: -9, marginTop: -10}}><div>Virements</div><div style={{marginTop: -5}}>Entrants France</div></div>),
    accessor: "VirementRentrantFrance",
    Filter: ColumnFilter,
    width: 170,
    padding: 27,
    wide: 'yes',
    post: 'yes',
    mobile: 'no',
    Cell : e => {
      
        return (
          <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
          <div style={{fontSize: 20, marginTop: 10}}>{e.value}</div>
        </div>
        )
      
  }},

  {
    Header: () => (<div style={{float: 'left', marginLeft:2, marginRight: -9, marginTop: -10}}><div>Virements</div><div style={{marginTop: -5}}>Entrants UE</div></div>),
    accessor: "VirementRentrantZoneEuro",
    Filter: ColumnFilter,
    width: 150,
    padding: 27,
    wide: 'yes',
    post: 'yes',
    mobile: 'no',
    Cell : e => {
      
        return (
          <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
          <div style={{fontSize: 20, marginTop: 10}}>{e.value}</div>
        </div>
        )
      
  }},


  {
    Header: () => (<div style={{float: 'left', marginLeft:15, marginRight: -9, marginTop: -10}}><div>Virements ent.</div><div style={{marginTop: -5}}>hors UE</div></div>),
    accessor: "VirementRentrantHorsZoneEuro",
    Filter: ColumnFilter,
    width: 150,
    padding: 27,
    wide: 'yes',
    post: 'yes',
    mobile: 'no',
    Cell : e => {
      
        return (
          <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
          <div style={{fontSize: 20, marginTop: 10}}>{e.value}</div>
        </div>
        )
      
  }},

  {
    Header: () => (<div style={{float: 'left', marginLeft:19, marginRight: -9, marginTop: -10}}><div>Virements Entrants</div><div style={{marginTop: -5}}>Hors UE Taux</div></div>),
    accessor: "VirementRentrantHorsZoneEuroTaux",
    Filter: ColumnFilter,
    width: 170,
    padding: 27,
    wide: 'yes',
    post: 'yes',
    mobile: 'no',
    Cell : e => {
      
        return (
          <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
          <div style={{fontSize: 20, marginTop: 10}}>{e.value}</div>
        </div>
        )
      
  }},
  //////////Découverts ////////////
  {
    Header: () => (<div style={{float: 'left', marginLeft:22, marginRight: -9, marginTop: -10}}><div>Intérêts Découverts</div><div style={{marginTop: -5}}>Authorisé</div></div>),
    accessor: "InteretsDecouvertAuthorise",
    Filter: ColumnFilter,
    width: 220,
    padding: 27,
    wide: 'yes',
    post: 'yes',
    mobile: 'no',
    Cell : e => {
      
        return (
          <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
          <div style={{fontSize: 20, marginTop: 10}}>{e.value}</div>
        </div>
        )
      
  }},

  {
    Header: () => (<div style={{float: 'left', marginLeft:2, marginRight: -9, marginTop: -10}}><div>Intérêts Découverts</div><div style={{marginTop: -5}}>Authorisé TAEG</div></div>),
    accessor: "InteretsDecouvertAuthoriseTAEG",
    Filter: ColumnFilter,
    width: 210,
    padding: 27,
    wide: 'yes',
    post: 'yes',
    mobile: 'no',
    Cell : e => {
      
        return (
          <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
          <div style={{fontSize: 20, marginTop: 10}}>{e.value}</div>
        </div>
        )
      
  }},


  {
    Header: () => (<div style={{float: 'left', marginLeft:15, marginRight: -9, marginTop: -10}}><div>Intérêts Découvert</div><div style={{marginTop: -5}}>Non Authorisé</div></div>),
    accessor: "InteretsDecouvertNonAuthorise",
    Filter: ColumnFilter,
    width: 210,
    padding: 27,
    wide: 'yes',
    post: 'yes',
    mobile: 'no',
    Cell : e => {
      
        return (
          <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
          <div style={{fontSize: 20, marginTop: 10}}>{e.value}</div>
        </div>
        )
      
  }},

  {
    Header: () => (<div style={{float: 'left', marginLeft:19, marginRight: -9, marginTop: -10}}><div>Intérêts Découvert</div><div style={{marginTop: -5}}>Non Authorisé TAEG</div></div>),
    accessor: "InteretsDecouvertNonAuthoriseTAEG",
    Filter: ColumnFilter,
    width: 150,
    padding: 27,
    wide: 'yes',
    post: 'yes',
    mobile: 'no',
    Cell : e => {
      
        return (
          <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
          <div style={{fontSize: 20, marginTop: 10}}>{e.value}</div>
        </div>
        )
      
  }},

  {
    Header: () => (<div style={{float: 'left', marginLeft:19, marginRight: -9, marginTop: -10}}><div>Commission</div><div style={{marginTop: -5}}>D'Intervention</div></div>),
    accessor: "CommissionDintervention",
    Filter: ColumnFilter,
    width: 150,
    padding: 27,
    wide: 'yes',
    post: 'yes',
    mobile: 'no',
    Cell : e => {
      
        return (
          <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
          <div style={{fontSize: 20, marginTop: 10}}>{e.value}</div>
        </div>
        )
      
  }},


  //////////Irrégularités ////////////
  {
    Header: () => (<div style={{float: 'left', marginLeft:22, marginRight: -9, marginTop: -10}}><div>Rejet</div><div style={{marginTop: -5}}>Virement</div></div>),
    accessor: "RejetDunVirement",
    Filter: ColumnFilter,
    width: 170,
    padding: 27,
    wide: 'yes',
    post: 'yes',
    mobile: 'no',
    Cell : e => {
      
        return (
          <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
          <div style={{fontSize: 20, marginTop: 10}}>{e.value}</div>
        </div>
        )
      
  }},

  {
    Header: () => (<div style={{float: 'left', marginLeft:2, marginRight: -9, marginTop: -10}}><div>Rejet</div><div style={{marginTop: -5}}>Prélèvement</div></div>),
    accessor: "RejetDunPrelevement",
    Filter: ColumnFilter,
    width: 170,
    padding: 27,
    wide: 'yes',
    post: 'yes',
    mobile: 'no',
    Cell : e => {
      
        return (
          <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
          <div style={{fontSize: 20, marginTop: 10}}>{e.value}</div>
        </div>
        )
      
  }},


  {
    Header: () => (<div style={{float: 'left', marginLeft:15, marginRight: -9, marginTop: -10}}><div>Opposition</div><div style={{marginTop: -5}}>Prélèvement</div></div>),
    accessor: "OppositionDunPrelevement",
    Filter: ColumnFilter,
    width: 165,
    padding: 27,
    wide: 'yes',
    post: 'yes',
    mobile: 'no',
    Cell : e => {
      
        return (
          <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
          <div style={{fontSize: 20, marginTop: 10}}>{e.value}</div>
        </div>
        )
      
  }},

  {
    Header: () => (<div style={{float: 'left', marginLeft:19, marginRight: -9, marginTop: -10}}><div>Opposition</div><div style={{marginTop: -5}}>Chèque</div></div>),
    accessor: "OppositionDunCheque",
    Filter: ColumnFilter,
    width: 165,
    padding: 27,
    wide: 'yes',
    post: 'yes',
    mobile: 'no',
    Cell : e => {
      
        return (
          <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
          <div style={{fontSize: 20, marginTop: 10}}>{e.value}</div>
        </div>
        )
      
  }},

  {
    Header: () => (<div style={{float: 'left', marginLeft:19, marginRight: -9, marginTop: -10}}><div>Chèque </div><div style={{marginTop: -5}}>Défaut Provision</div></div>),
    accessor: "ChequeRejetPourDefautDeProvision",
    Filter: ColumnFilter,
    width: 150,
    padding: 27,
    wide: 'yes',
    post: 'yes',
    mobile: 'no',
    Cell : e => {
      
        return (
          <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
          <div style={{fontSize: 20, marginTop: 10}}>{e.value}</div>
        </div>
        )
      
  }},

  //////////Retraits et Paiements À L'étranger ////////////

  {
    Header: () => (<div style={{float: 'left', marginLeft:22, marginRight: -9, marginTop: -10}}><div>Retraits</div><div style={{marginTop: -5}}>UE</div></div>),
    accessor: "Retraits UE",
    Filter: ColumnFilter,
    width: 170,
    padding: 27,
    wide: 'yes',
    post: 'yes',
    mobile: 'no',
    Cell : e => {
      
        return (
          <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
          <div style={{fontSize: 20, marginTop: 10}}>{e.value}</div>
        </div>
        )
      
  }},

  {
    Header: () => (<div style={{float: 'left', marginLeft:29, marginRight: -9, marginTop: -10}}><div>Retraits</div><div style={{marginTop: -5}}>hors UE</div></div>),
    accessor: "RetraitsHorsUE",
    Filter: ColumnFilter,
    width: 150,
    padding: 27,
    wide: 'yes',
    post: 'yes',
    mobile: 'no',
    Cell : e => {
      
        return (
          <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
          <div style={{fontSize: 20, marginTop: 10}}>{e.value}</div>
        </div>
        )
      
  }},


  {
    Header: () => (<div style={{float: 'left', marginLeft:15, marginRight: -9, marginTop: -10}}><div>Frais Change</div><div style={{marginTop: -5}}>Visa Mastercard</div></div>),
    accessor: "FraisChangeVisaMastercard",
    Filter: ColumnFilter,
    width: 170,
    padding: 27,
    wide: 'yes',
    post: 'yes',
    mobile: 'no',
    Cell : e => {
      
        return (
          <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
          <div style={{fontSize: 20, marginTop: 10}}>{e.value}</div>
        </div>
        )
      
  }},

  {
    Header: () => (<div style={{float: 'left', marginLeft:19, marginRight: -9, marginTop: -10}}><div>Paiements</div><div style={{marginTop: -5}}>UE</div></div>),
    accessor: "PaiementsUE",
    Filter: ColumnFilter,
    width: 150,
    padding: 27,
    wide: 'yes',
    post: 'yes',
    mobile: 'no',
    Cell : e => {
      
        return (
          <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
          <div style={{fontSize: 20, marginTop: 10}}>{e.value}</div>
        </div>
        )
      
  }},

  {
    Header: () => (<div style={{float: 'left', marginLeft:19, marginRight: -9, marginTop: -10}}><div>Paiements</div><div style={{marginTop: -5}}>Hors UE</div></div>),
    accessor: "PaiementsHorsUE",
    Filter: ColumnFilter,
    width: 150,
    padding: 27,
    wide: 'yes',
    post: 'yes',
    mobile: 'no',
    Cell : e => {
      
        return (
          <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
          <div style={{fontSize: 20, marginTop: 10}}>{e.value}</div>
        </div>
        )
      
  }},
  
///////////// Assurances //////////////
{
  Header: () => (<div style={{float: 'left', marginLeft:19, marginRight: -9, marginTop: -10}}><div>Assistance</div><div style={{marginTop: -5}}>Rapatriment</div></div>),
  accessor: "AssistanceRapatriment",
  Filter: ColumnFilter,
  width: 160,
  padding: 27,
  wide: 'yes',
  post: 'yes',
  mobile: 'no',
  Cell : e => {
    
      return (
        <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
        <div style={{fontSize: 20, marginTop: 10}}>{e.value}</div>
      </div>
      )
    
}},

{
  Header: () => (<div style={{float: 'left', marginLeft:19, marginRight: -9, marginTop: -10}}><div>Limite Assistance</div><div style={{marginTop: -5}}>Rapatriment</div></div>),
  accessor: "LimiteAssistanceRapatriment",
  Filter: ColumnFilter,
  width: 160,
  padding: 27,
  wide: 'yes',
  post: 'yes',
  mobile: 'no',
  Cell : e => {
    
      return (
        <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
        <div style={{fontSize: 20, marginTop: 10}}>{e.value}</div>
      </div>
      )
    
}},

{
  Header: () => (<div style={{float: 'left', marginLeft:19, marginRight: -9, marginTop: -10}}><div>Assurance</div><div style={{marginTop: -5}}>Voyage</div></div>),
  accessor: "AssuranceVoyages",
  Filter: ColumnFilter,
  width: 160,
  padding: 27,
  wide: 'yes',
  post: 'yes',
  mobile: 'no',
  Cell : e => {
    
      return (
        <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
        <div style={{fontSize: 20, marginTop: 10}}>{e.value}</div>
      </div>
      )
    
}},

{
  Header: () => (<div style={{float: 'left', marginLeft:19, marginRight: -9, marginTop: -10}}><div>Garantie Vehicule</div><div style={{marginTop: -5}}>De Location</div></div>),
  accessor: "GarantieVehiculeDeLocation",
  Filter: ColumnFilter,
  width: 160,
  padding: 27,
  wide: 'yes',
  post: 'yes',
  mobile: 'no',
  Cell : e => {
    
      return (
        <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
        <div style={{fontSize: 20, marginTop: 10}}>{e.value}</div>
      </div>
      )
    
}},

//////// FRAIS BANCAIRE ///////
{
  Header: () => (<div style={{float: 'left', marginLeft:29, marginRight: -9, marginTop: -10}}><div>Tenue de</div><div style={{marginTop: -5}}>compte</div></div>),
  // Header: 'Coût mensuel',
  accessor: 'TenueDeCompte',
  Filter: ColumnFilter,
  width: 140,
  padding: 27,
  Cell : e => {
    
    if(e.value === 'illimité'){
      return (
        <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
          <div style={{fontSize: 20, padding: 8}}>{e.value}</div>
        </div> 
      )
    } else {
      return (
        <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
        <div style={{fontSize: 24, marginTop: 10}}>{e.value}€</div>
        <div style={{fontWeight: 300, fontSize: 14, marginTop: -4}}>par mois</div>
      </div>
      )
    }
}},

{
  Header: () => (<div style={{float: 'left', marginLeft:29, marginRight: -9, marginTop: -10}}><div>Lettre d'info</div><div style={{marginTop: -5}}>sans provision</div></div>),
  // Header: 'Coût mensuel',
  accessor: 'LettreInformationSansProvision',
  Filter: ColumnFilter,
  width: 150,
  padding: 27,
  Cell : e => {
    
    if(e.value === 'illimité'){
      return (
        <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
          <div style={{fontSize: 20, padding: 8}}>{e.value}</div>
        </div> 
      )
    } else {
      return (
        <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
        <div style={{fontSize: 24, marginTop: 10}}>{e.value}</div>
        <div style={{fontWeight: 300, fontSize: 14, marginTop: -4}}>par lettre</div>
      </div>
      )
    }
}},

//////// CONDITIONS ////////////

{
  Header: () => (<div style={{float: 'left', marginLeft:29, marginRight: -9, marginTop: -10}}><div>Conditions</div><div style={{marginTop: -5}}>de l'offre</div></div>),
  accessor: "ConditionsOffre",
  Filter: ColumnFilter,
  width: 440,
  height: 400,
  padding: 27,
  Cell : e => {
    if(e.value === 'Sans condition'){
      return (
        <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
             <div style={{fontSize: 24, marginTop: 10}}>Sans</div>
        <div style={{fontWeight: 300, fontSize: 14, marginTop: -4}}>condition</div>
        </div> 
      )
    } else {
      return (
        <div style={{fontFamily: '"Helvetica", Sans-serif'}}>
        <div style={{fontSize: 14, marginTop: 10, whiteSpace: 'normal', textAlign: 'left'}}><p style={{fontSize: 14}}>{e.value}</p></div>
        {/* <div style={{fontWeight: 300, fontSize: 14, marginTop: -4}}>{e.value.split(',')[1]}</div> */}
      </div>
      )
    }
}},



////////  STANDARD /////////////
  {
    Header: 'En savoir +',
    accessor: 'BanqueWebsite',
    width: 170,
    padding: 18,
    wide: 'yes',
    post: 'yes',
    mobile: 'no',
    Cell: e =>{
      let val = e.value.split(',')

      return (
        // <span>{e.value}</span>
        <div style={{padding: 6}}>

<a href={`/go/?go=${val[0]}`}
         target='_blank' rel="noreferrer">
                <BS.Button id="comparateurButton" type="submit" className="btn-lg" style={{height: 40, backgroundColor: '#E5234F', borderColor: '#E5234F', width: 120, padding: 7, fontSize: 14, boxShadow: '0 0 8px 0 rgb(0 0 0 / 30%)'}}>+ d'infos <FontAwesomeIcon icon={faAngleDoubleRight} style={{marginTop: 0, marginBottom: -3, fontSize: 24, marginLeft: 5}}/></BS.Button>
          </a>
        </div>
      )
    },
  },
]